import { PhotosApi } from "@/Apis/PhotosApi";
import { useAuthentication } from "@/Slices/authenticationSlice";
import { getConfig } from "@/Apis/getConfig";

export function usePhotosApi(): PhotosApi {
  const { accessToken } = useAuthentication();

  return new PhotosApi(getConfig().basePath, accessToken);
}
